export class PaginationInfinityBrowser {
    events = {
        browse: 'infinity-browse'
    };

    eps = 300; // epsilon ('400px' margin in height)

    // staff
    window = $(window);
    button;

    constructor() {
        this.init();
    }

    init() {
        this.button = $('.pagination-infinity-browser__button');

        if (!this.button.length || this.button.length > 1) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.window.on('scroll', () => this.onScroll());
    }

    onScroll() {
        if (this.isVisible()) {
            this.window.trigger(this.events.browse, {
                target: this.button
            });
        }
    }

    // auxiliary
    isVisible() {
        return this.button.length && (this.window.scrollTop() + this.window.outerHeight() + this.eps) >= this.button.offset().top;
    }

    // fn's
    getEvents(e) {
        return this.events[e] || this.events;
    }
}
